module.exports = __webpack_public_path__ + "static/media/crossingsImage1.96363cb2.png";